import React from "react";

import styled from "styled-components/macro";

import { ExclamationIcon } from "components/Icons";
import { Row } from "components/Layout";

const Wrapper = styled(Row)<{ visible: boolean; alignItems?: string }>`
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  padding: 12px 18px;
  border: 1px solid ${({ theme }) => theme.colors.error};
  background-color: #fff;
  color: ${({ theme }) => theme.colors.error};
  font-weight: bold;
`;

const IconWrapper = styled.div<{ iconPaddingTop?: number }>`
  flex-grow: 0;
  padding-right: 18px;
  ${({ iconPaddingTop }) =>
    iconPaddingTop !== undefined ? `padding-top: ${iconPaddingTop}px;` : ""}
`;

interface LargeErrorMessageProps {
  children?: React.ReactNode;
  className?: string;
  iconPaddingTop?: number;
  alignItems?: string;
  visible?: boolean;
}

const LargeErrorMessage = ({
  children,
  className,
  iconPaddingTop = 0,
  alignItems = "center",
  visible = true,
}: LargeErrorMessageProps) => (
  <Wrapper visible={visible} className={className} alignItems={alignItems}>
    <IconWrapper iconPaddingTop={iconPaddingTop}>
      <ExclamationIcon />
    </IconWrapper>
    <div>{children}</div>
  </Wrapper>
);

export default LargeErrorMessage;

export const FullWidthSlimErrorMessage = styled(LargeErrorMessage)`
  width: 100%;
  justify-content: center;
  padding: ${({ theme }) => `${theme.space[1]}px ${theme.space[2]}px`};
  line-height: 1;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
`;
